// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--1Sr7y","copyright":"footer-module--copyright--2acot"};